import { AbstractControl, ValidatorFn } from '@angular/forms';
import { TableRowValueList } from '@vinnova/ui';
import { BudgetValidation } from '@vinnova/validation';
import { Kostnadstyp } from '../budget.interface';

export interface AbstractControlWarn extends AbstractControl {
  warnings: unknown;
}

export function BudgetIndirektaKostnaderWarning() {
  return (control: AbstractControlWarn): ValidatorFn => {
    if (control.value) {
      const parsedValue = JSON.parse(control.value);
      const lonekostnaderTotal = calculateRowSum(
        Kostnadstyp.LONEKOSTNADER,
        parsedValue,
      );
      const indirektaKostnaderTotal = calculateRowSum(
        Kostnadstyp.INDIREKTAKOSTNADER,
        parsedValue,
      );
      const valObject = {
        [`${BudgetValidation.IndirektaKostnaderOverLonekostnader}_${Kostnadstyp.INDIREKTAKOSTNADER}`]: true,
      };

      control.warnings =
        indirektaKostnaderTotal / lonekostnaderTotal > 0.3
          ? valObject
          : undefined;
    }

    return undefined;
  };
}

function calculateRowSum(
  kostnadsrad: Kostnadstyp,
  tabellrader: TableRowValueList,
): number {
  return tabellrader
    .filter((x) => x.rowId === kostnadsrad)
    .map((x) => x.value)
    .reduce((a: number, b: number) => a + b, 0);
}
